export const GET_LOGIN_REQUEST = "GET_LOGIN_REQUEST";
export const GET_LOGIN_SUCCESS = "GET_LOGIN_SUCCESS";
export const GET_LOGIN_FAILURE = "GET_LOGIN_FAILURE";

export const GET_SIGNUP_REQUEST = "GET_SIGNUP_REQUEST";
export const GET_SIGNUP_SUCCESS = "GET_SIGNUP_SUCCESS";
export const GET_SIGNUP_FAILURE = "GET_SIGNUP_FAILURE";

export const HANDLE_LOGOUT = "HANDLE_LOGOUT";
